/* eslint-disable */
function getStandaloneLoader(packageName, versionKey) {

    function loadResourcesBySystemJS(resources) {
        return Promise.all(
            resources.map(r =>
                /* use SystemJS to load packages */
                window.System.import(r)
            )
        ).then(([...results]) =>
            Promise.resolve(
                ...results
                .map(m => {
                    if (!m) return undefined;

                    if ("__useDefault" in m) {
                        return m.__useDefault;
                    }

                    if ("__esModule" in m) {
                        return m.default;
                    }

                    return m;
                })
                .reverse()
            )
        );
    }

    function loadCss(url) {
        const tag = document.createElement('link');
        tag.setAttribute('rel', 'stylesheet');
        tag.setAttribute('type', 'text/css');
        tag.setAttribute('href', url);
        document.getElementsByTagName('head')[0].appendChild(tag);
    }

    function loadJs(url) {
        return new Promise((resolve, reject) => {
            const tag = document.createElement('script');
            tag.setAttribute('src', url);
            tag.onload = e => resolve(e);
            tag.onerror = e => reject(e);
            document.getElementsByTagName('head')[0].appendChild(tag);
        });
    }

    function loadJSResources(packageManifest, parentUrl, packageName) {
        const jsResources = packageManifest[packageName].js.map(url => parentUrl + url);
        const pkgRequires = packageManifest[packageName].requires;
        if(pkgRequires && pkgRequires.length > 0) {
            return Promise.all(pkgRequires.map((req)=>{
                const dependency = req;
                return loadJSResources(packageManifest, parentUrl, dependency).then(() => {
                    return loadResourcesBySystemJS(jsResources);
                });
            }));
        } else {
            return loadResourcesBySystemJS(jsResources);
        }
    }

    function load() {
        // get base url from global variables
        // window.__transition__cdn__url__ = 'https://cdn-dev01.seismic-dev.com/static/';
        var packageVersion = '';

        // e.g. https://cdn-dev01.seismic-dev.com/static/seismic-engagement-viewer-ui/manifest.js
        var cdnUrl = window.__transition_cdn_url__;
        var localCdnUrl = window.__transition_local_cdn_url__;
        var baseURL = cdnUrl + packageName;
        var versionPath = baseURL + '/manifest.js?t=' + new Date().getTime();
        var parentUrl = '';

        return loadJs(versionPath).then(function () {
            packageVersion = window[versionKey];
            var systemJsBackupCDN = baseURL + '/' + packageName + '.systemjs.js';

            if (!!localCdnUrl) {
                systemJsBackupCDN = localCdnUrl + packageName + '.systemjs.js';
            }
            return loadJs(systemJsBackupCDN);
        }).then(function () {
            window.System.config({
                meta: {
                    '*': {
                        format: 'cjs',
                        cjsRequireDetection: false
                    }
                }
            });
            // get package manifest
            // e.g. http://cdn-dev01.seismic-dev.com/static/seismic-engagement-viewer-ui/seismic-engagement-viewer-ui.manifest.0.1.0-9.json

            parentUrl = baseURL + '/';

            // For local development.
            // window.__transition_local_cdn_url__ value could be empty string or undefined
            // https://127.0.0.1:4444/static/seismic-engagement-viewer-ui.manifest.0.1.0-9.json
            if (!!localCdnUrl) {
                packageVersion = window[versionKey].split('-')[0];
                parentUrl = localCdnUrl;
            }

            var packageManifestUrl =
                parentUrl + packageName + '.manifest.' +
                packageVersion + '.json';

            return new Promise((resolve, reject) => {
                fetch(packageManifestUrl).then(function (response) {
                    response.json().then(function (packageManifest) {
                        resolve(packageManifest);
                    });
                });
            });
        }).then(function (packageManifest) {
            const packageNameWithSemver = `${packageName}@${packageVersion}`;
            const cssResources = packageManifest[packageNameWithSemver].css.map(url => parentUrl + url);
            cssResources.forEach(href => {
                loadCss(href)
            });

            return loadJSResources(packageManifest, parentUrl, packageNameWithSemver).then((moduleExport) =>{
                return { ui: moduleExport[0] || moduleExport, imageCDNUrl: parentUrl }
            });
        });
    }

    return {
        load
    };
}

export default getStandaloneLoader;